export const getPushNotifications = (payload?: any) => ({
    type: "@saga/GET_PUSH_NOTIFICATIONS",
    payload
  });
  